export const scrollToId = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(id, { offset: -64 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
};
